import StockPage from "@/pages/StockPage";

export default function StockAvailablePage({ user }) {
  return <StockPage quickLookup user={user} />;
}